import AxiosInstance from "./axiosInstance";

export const getAllBanner = () => {
  return AxiosInstance.get("/banner")
    .then((res) => {
      if (res.status === 200) return res.data;
    })
    .catch((err) => {
      console.error(err);
      throw err;
    });
};
export const uploadBanner = (file) => {
  var formdata = new FormData();
  formdata.append(`file`, file);

  return AxiosInstance.post("/banner", formdata, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  })
    .then((res) => {
      if (res.status === 200) return res.data;
    })
    .catch((err) => {
      console.error(err);
      throw err;
    });
};
export const deleteBanner = (id) => {
  return AxiosInstance.delete(`/banner/${id}`)
    .then((res) => {
      if (res.status === 200) return res.data;
    })
    .catch((err) => {
      console.error(err);
      throw err;
    });
};
export const setFavouriteBanner = (id, bool) => {
  return AxiosInstance.patch(`/banner/${id}`, {
    is_fav: bool,
  })
    .then((res) => {
      if (res.status === 200) return res.data;
    })
    .catch((err) => {
      console.error(err);
      throw err;
    });
};
